import { useEffect, useLayoutEffect, useRef, useState } from "react";

/** Нижняя граница фиксированной шапки портала — боковые панели открываются под ней */
const getHeaderOffset = () => {
  const header = document.querySelector(".header");
  return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
};

/**
 * Общее поведение боковых панелей раздела «Учет и планирование»:
 * отступ под шапку, закрытие по Esc и блокировка прокрутки страницы.
 * Возвращает верхний отступ для оверлея.
 */
function useSidePanel(isOpen, onClose) {
  const [headerOffset, setHeaderOffset] = useState(0);
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  });

  useLayoutEffect(() => {
    if (!isOpen) return undefined;

    const updateHeaderOffset = () => setHeaderOffset(getHeaderOffset());
    const handleEscape = (event) => {
      if (event.key === "Escape") onCloseRef.current();
    };

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    updateHeaderOffset();
    document.addEventListener("keydown", handleEscape);
    window.addEventListener("resize", updateHeaderOffset);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", handleEscape);
      window.removeEventListener("resize", updateHeaderOffset);
    };
  }, [isOpen]);

  return headerOffset;
}

export default useSidePanel;
